import { Form, Formik } from 'formik';
import { FormikConfig } from 'formik/dist/types';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useCallback } from 'react';
import { FC } from 'react';
import React from 'react';
import { usePrevious } from 'react-use';
import * as yup from 'yup';
import { getHref } from '../../../utils/getHref';
import { useUserContext } from '../../UserContext';
import { Login } from './Login';
import { LoginFormData } from './LoginForm.type';

const validationSchema = yup.object({
    email: yup.string(),
    password: yup.string(),
    thumbprint: yup.string(),
    signature: yup.string(),
});

const useFallingEffect = (effect: () => void, value: any) => {
    const prevValue = usePrevious(value);

    useEffect(() => {
        if (prevValue && !value) {
            effect();
        }
    }, [effect, prevValue, value]);
};

interface Props {
    redirectUrl: string;
}

export const LoginForm: FC<Props> = ({ redirectUrl }) => {
    const { user, login, loginState } = useUserContext();

    const initialValues = useMemo(
        () => ({
            email: '',
            password: '',
            thumbprint: '',
            signature: '',
        }),
        []
    );

    const handleSubmit = useCallback<FormikConfig<LoginFormData>['onSubmit']>(
        async (values) => {
            const formData = values.signature
                ? { ...values, password: '' }
                : values;
            await login(formData);
        },
        [login]
    );

    useFallingEffect(() => {
        if (user) {
            window.location.href = getHref(redirectUrl);
        }
    }, loginState.loading);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            <Form noValidate>
                <Login error={loginState.error?.message} />
            </Form>
        </Formik>
    );
};
